import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter);

const routes = [{
		path: '*',
		name: '404',
		component: () => import('../views/404.vue')
	},
	{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/introduce/yksz.html',
		name: 'introduce',
		component: () => import('../views/Introduce.vue')
	},
	{
		path: '/introduce/lshj.html',
		name: 'introduce',
		component: () => import('../views/Introduce.vue')
	},
	{
		path: '/introduce/ActivityPhotos.html',
		name: 'introduce',
		component: () => import('../views/Introduce.vue')
	},
	{
		path: '/introduce/ryjx.html',
		name: 'introduce',
		component: () => import('../views/Introduce.vue')
	},
	{
		path: '/field.html',
		name: 'field',
		component: () => import('../views/Field.vue')
	},
	{
		path: '/team.html',
		name: 'team',
		component: () => import('../views/team/index.vue'),
		children: [{
			path: '/team/:lawyerType.html',
			name: 'team',
			component: () => import('../views/team/list.vue'),
		}, ],
		props: true
	},
	{
		path: '/team/:lawyerType/:id.html',
		name: 'team-details',
		component: () => import('../views/team/details.vue'),
		children: [{
			path: '/team/all/:id.html',
			name: 'team-all-details',
			component: () => import('../views/team/details.vue'),
		}, ],
		props: true
	},
	{
		path: '/dynamic.html',
		name: 'dynamic',
		component: () => import('../views/article/dynamic.vue')
	},
	{
		path: '/party.html',
		name: 'party',
		component: () => import('../views/article/party.vue')
	},
	{
		path: '/dynamic/:id.html',
		name: 'article-details',
		component: () => import('../views/article/details.vue'),
		props: true,
	},
	{
		path: '/party/:id.html',
		name: 'article-details1',
		component: () => import('../views/article/details1.vue'),
		props: true,
	},
	{
		path: '/contact.html',
		name: 'contact',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/About.vue')
	},
	{
		path: '/case.html',
		name: 'case',
		component: () => import('../views/cases/index.vue'),
		children: [{
			path: '/:caseType.html',
			name: 'case',
		}, ],
	},
	{	
		path: '/case/:caseType/:id.html',
		name: 'Casedetail',
		component: () => import('../views/cases/details.vue'),
		props: true,
	},

]

const router = new VueRouter({
	mode: 'history', //去掉url中的#
	scrollBehavior(to,form,saveTop){
		if(saveTop) {
			return saveTop
		}else{
			return {x:0,y:0}
		}
	},
	routes
})

export default router
